import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Page render error:", error, info);
  }
  componentDidUpdate(prev) {
    if (prev.routeKey !== this.props.routeKey && this.state.error) {
      this.setState({ error: null });
    }
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="page-error">
          <div className="w-14 h-14 rounded-2xl bg-rose-50 text-rose-500 flex items-center justify-center text-2xl mb-4">!</div>
          <h2 className="font-heading font-bold text-[#312E81] text-lg">This page hit an error</h2>
          <p className="text-sm text-slate-500 mt-1 max-w-md">{String(this.state.error?.message || this.state.error)}</p>
          <button onClick={() => window.location.reload()} className="mt-4 px-4 py-2 rounded-lg bg-[#4F46E5] text-white text-sm font-semibold">Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
